import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Form } from "react-bootstrap";
import { Button } from "../../../components/ui";

function PaidModal({
  show,
  onHide,
  clinics = [],
  staff = [],
  patientId,
  treatmentPlanId,
  defaultClinicId = "",
  onSave,
}) {
  const { t } = useTranslation("patient");
  const [newPay, setNewPay] = useState({
    clinicId: "",
    paymentMethod: "0",
    status: "0",
    price: "",
    id_user_owner: "",
  });

  useEffect(() => {
    if (show) {
      setNewPay({
        clinicId: defaultClinicId ? String(defaultClinicId) : "",
        paymentMethod: "0",
        status: "0",
        price: "",
        id_user_owner: "",
      });
    }
  }, [show, defaultClinicId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPay((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSavePay = () => {
    // Формируем данные для отправки
    const paymentData = {
      id_patient: patientId,
      id_clinic: newPay.clinicId,
      id_treatment_plan: treatmentPlanId,
      payment_method: newPay.paymentMethod,
      status: newPay.status,
      price: newPay.price,
      ...(newPay.id_user_owner
        ? { id_user_owner: newPay.id_user_owner }
        : {}),
    };

    if (onSave) {
      onSave(paymentData); // ← вызывает handleSavePay из PatientPlan
    }
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{t("paidModal.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* СПИСОК КЛИНИК */}
          <Form.Group className="mb-3">
            <Form.Label>{t("paidModal.clinicLabel")}</Form.Label>
            <Form.Select
              name="clinicId"
              value={newPay.clinicId}
              onChange={handleInputChange}>
              <option value="">{t("paidModal.selectClinic")}</option>
              {clinics.map((clinic) => (
                <option key={clinic.id} value={clinic.id}>
                  {clinic.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("paidModal.ownerLabel")}</Form.Label>
            <Form.Select
              name="id_user_owner"
              value={newPay.id_user_owner}
              onChange={handleInputChange}>
              <option value="">{t("paidModal.notSelected")}</option>
              {staff.map((person) => (
                <option key={person.id} value={person.id}>
                  {person.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Метод оплаты */}
          <Form.Group className="mb-3">
            <Form.Label>{t("paidModal.methodLabel")}</Form.Label>
            <Form.Select
              name="paymentMethod"
              value={newPay.paymentMethod}
              onChange={handleInputChange}>
              <option value="0">{t("paidModal.methodNotSelected")}</option>
              <option value="1">{t("paidModal.methodCash")}</option>
              <option value="2">{t("paidModal.methodCard")}</option>
              <option value="3">{t("paidModal.methodInvoice")}</option>
            </Form.Select>
          </Form.Group>

          {/* Статус */}
          <Form.Group className="mb-3">
            <Form.Label>{t("paidModal.statusLabel")}</Form.Label>
            <Form.Select
              name="status"
              value={newPay.status}
              onChange={handleInputChange}>
              <option value="0">{t("paidModal.statusNone")}</option>
              <option value="1">{t("paidModal.statusPending")}</option>
              <option value="10">{t("paidModal.statusPaid")}</option>
            </Form.Select>
          </Form.Group>

          {/* Сумма */}
          <Form.Group className="mb-3">
            <Form.Label>{t("paidModal.amountLabel")}</Form.Label>
            <Form.Control
              type="number"
              name="price"
              value={newPay.price}
              onChange={handleInputChange}
              min="0"
              placeholder="0"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t("actions.cancel", { ns: "common" })}
        </Button>
        <Button
          variant="primary"
          onClick={handleSavePay}
          disabled={!newPay.clinicId || !newPay.price}>
          {t("actions.save", { ns: "common" })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PaidModal;
